import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import { BaseEntity, generateEntityId, RelatedEntity, User } from '@ztechapps/common.contract'
import { ScanBatchStatusEnum } from '../enums/ScanBatchStatusEnum'
import { Assessment } from './Assessment'

@ObjectType()
@InputType('ScanBatchItemInput')
export class ScanBatchItem {
  @Field(() => String)
  @Prop({ type: String, required: true })
  imageUrl: string

  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  resultId?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  studentName?: string

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  failed: boolean

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  error?: string
}

@ObjectType('ScanBatch')
@InputType('ScanBatchInput')
@modelOptions({ schemaOptions: { timestamps: true, collection: 'scanbatches' } })
export class ScanBatch extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('sbat') })
  declare _id: string

  /**
   * The parent assessment. Ownership is reached through this relation, and is
   * also denormalized onto `owner` for synchronous owner-scoped queries.
   */
  @Field(() => Assessment)
  @Prop({ type: RelatedEntity })
  assessment: ReturnType<() => Assessment>

  /**
   * Denormalized owner (the teacher who owns the parent assessment). Stamped on
   * create so every tenancy-scoped read/write can isolate by owner within the
   * shared DFT tenant (mirrors AssessmentResult.owner).
   */
  @Field(() => User)
  @Prop({ type: RelatedEntity })
  owner: ReturnType<() => User>

  @Field(() => ScanBatchStatusEnum)
  @Prop({ type: String, enum: ScanBatchStatusEnum, required: true, default: ScanBatchStatusEnum.Queued })
  declare status: ScanBatchStatusEnum

  @Field(() => Float)
  @Prop({ type: Number, default: 0 })
  totalImages: number

  @Field(() => Float)
  @Prop({ type: Number, default: 0 })
  succeededCount: number

  @Field(() => Float)
  @Prop({ type: Number, default: 0 })
  failedCount: number

  @Field(() => [ScanBatchItem])
  @Prop({ type: [ScanBatchItem] }, PropType.ARRAY)
  items: ReturnType<() => ScanBatchItem[]>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  error?: string
}
